import BackgroundEffect from '../components/BackgroundEffect';
const UserAgreement = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>User Agreement</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. Introduction</h2>
                <p style={styles.paragraph}>
                    This <b>User Agreement</b> (“Agreement”) is a legal contract between <b>JSKM Technologies Private
                        Limited</b> (“Company,” “we,” “our,” or “us”) and you (“User,” “Client,” or “Customer”). It
                    governs your use of our websites, applications (including <b>TrustMee</b>), software, products,
                    and all related services offered under the JSKM Technologies brand.
                </p>
                <p style={styles.paragraph}>
                    By accessing or using our services, you agree to be bound by this Agreement, along with our <b>Terms & Conditions</b> and <b>Privacy Policy.</b> If you do not agree with any part of this Agreement,
                    please discontinue using our services immediately.
                </p>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Eligibility</h2>
                <p style={styles.paragraph}>To use our services, you must:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Be at least 18 years of age (or of legal age in your jurisdiction).</li>
                    <li style={styles.listItem}>
                        Have the legal authority to enter into this Agreement on behalf of yourself or your organization.
                    </li>
                </ul>
                <p style={styles.paragraph}>If you are using our services on behalf of a company, you represent that you are authorized to act on behalf of that company.</p>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. Scope of Services</h2>
                <p style={styles.paragraph}>JSKM Technologies provides professional services across multiple domains, including:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>IT Services:</strong> Website Development, App Development, AI Solutions, Software & Cloud Development.
                    </li>
                    <li style={styles.listItem}>
                        <strong>TrustMee Platform:</strong> Product authentication, warranty verification, and related app features.
                    </li>
                    <li style={styles.listItem}>
                        <strong>HR Consulting:</strong> Staffing, recruitment, and human resource management.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Medical Coding & Billing:</strong> Healthcare data processing, billing, and coding solutions.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Export & Import Services:</strong> Global trade support and logistics solutions.
                    </li>
                </ul>
                <p style={styles.paragraph}>
                    Specific project deliverables, timelines, and pricing are governed by separate written
                    proposals, statements of work, or service orders.
                </p>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Account Registration</h2>
                <p style={styles.paragraph}>
                    Some services (like TrustMee or development platforms) may require user account
                    registration. You agree to:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Provide accurate and complete information.</li>
                    <li style={styles.listItem}>Maintain confidentiality of your login credentials.</li>
                    <li style={styles.listItem}>Notify us immediately of unauthorized account access.</li>
                </ul>
                <p style={styles.paragraph}>
                    You are responsible for all activities under your account.
                </p>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. User Obligations</h2>
                <p style={styles.paragraph}>
                    By using our services, you agree that you will:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Use services only for lawful business or personal purposes.</li>
                    <li style={styles.listItem}>Not attempt to gain unauthorized access to our systems or servers.</li>
                    <li style={styles.listItem}>
                        Not copy, modify, or redistribute our proprietary materials without written consent.
                    </li>
                    <li style={styles.listItem}>Provide true and accurate information during project or service onboarding.</li>
                </ul>
                <p style={styles.paragraph}>
                    We reserve the right to suspend or terminate accounts violating these obligations.
                </p>
            </div>

            {/* Section 6 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>6. Fees, Invoicing, and Payment</h2>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Payments must be made directly to <b>JSKM Technologies Private Limited</b> as per the invoice.</li>
                    <li style={styles.listItem}>Fees and billing schedules are defined in project agreements or quotations.</li>
                    <li style={styles.listItem}>
                        All amounts are payable in full and non-refundable once services have been rendered.
                    </li>
                    <li style={styles.listItem}>We reserve the right to suspend or discontinue services for delayed or incomplete payments.</li>
                </ul>
            </div>

            {/* Section 7 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>7. Intellectual Property Rights</h2>
                <p style={styles.paragraph}>
                    All software, designs, documents, and materials developed or provided by JSKM Technologies
                    are our property unless otherwise stated in writing.<br /> Clients receive a limited,
                    non-transferable license to use deliverables for their business operations only.
                </p>
            </div>

            {/* Section 8 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>8. Data Privacy</h2>
                <p style={styles.paragraph}>
                    Your personal and business data are processed in accordance with our <b>Privacy Policy.</b> By
                    using our services, you consent to the collection and use of data as described in that
                    policy.
                </p>
            </div>

            {/* Section 9 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>9. Confidentiality</h2>
                <p style={styles.paragraph}>
                    Both parties agree to maintain the confidentiality of all proprietary, financial, and
                    project-related information shared during the course of engagement.<br />Confidential information will not be disclosed to third parties unless required by law or with written consent.
                </p>
            </div>

            {/* Section 10 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>10. Service Limitations</h2>
                <p style={styles.paragraph}>
                    While we strive to provide uninterrupted services, certain circumstances such as
                    maintenance or system updates may cause temporary disruptions. JSKM Technologies shall not
                    be held responsible for service unavailability caused by such factors.
                </p>
            </div>

            {/* Section 11 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>11. Prohibited Activities</h2>
                <p style={styles.paragraph}>
                    You may not:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Interfere with or disrupt our servers or networks.</li>
                    <li style={styles.listItem}>Reverse-engineer or attempt to extract source code from our software.</li>
                    <li style={styles.listItem}>Use our services to engage in illegal, unethical, or fraudulent activities.</li>
                </ul>
                <p style={styles.paragraph}>
                    Violation of these restrictions may result in immediate suspension or termination of your access.
                </p>
            </div>

            {/* Section 12 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>12. Termination</h2>
                <p style={styles.paragraph}>
                    We may suspend or terminate your account or access if:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>You breach this Agreement or any applicable law.</li>
                    <li style={styles.listItem}>You fail to make timely payments.</li>
                    <li style={styles.listItem}>You misuse or abuse our systems or data.</li>
                </ul>
                <p style={styles.paragraph}>
                    Upon termination, any outstanding amounts become immediately due.
                    Your right to use our services ends immediately.
                </p>
            </div>

            {/* Section 13 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>13. Disclaimers</h2>
                <p style={styles.paragraph}>
                    All services are provided on an <b>“as-is”</b> and <b>“as-available”</b> basis.<br/> JSKM Technologies does not
                    guarantee error-free operation or uninterrupted availability.<br/>We disclaim all implied warranties, including merchantability and fitness for a particular purpose.
                </p>
            </div>

            {/* Section 14 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>14. Limitation of Liability</h2>
                <p style={styles.paragraph}>
                    To the maximum extent permitted by law, JSKM Technologies shall not be liable for:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Any indirect, incidental, or consequential losses,</li>
                    <li style={styles.listItem}>Data loss, loss of revenue, or reputational damage,</li>
                    <li style={styles.listItem}>Any damages exceeding the amount paid for the specific service.</li>
                </ul>
            </div>

            {/* Section 15 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>15. Governing Law & Jurisdiction</h2>
                <p style={styles.paragraph}>
                    This Agreement is governed by the laws of <b>India.</b><br/> Any disputes shall be subject to the
                    exclusive jurisdiction of the <b>courts of Vijayawada, Andhra Pradesh.</b>
                </p>
            </div>

            {/* Section 16 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>16. Modifications to Agreement</h2>
                <p style={styles.paragraph}>
                    JSKM Technologies reserves the right to modify or update this User Agreement at any time.
                    Revisions will be posted on our website with the updated <b>Effective Date.</b><br/>
                    Your continued use of services after updates signifies your acceptance of the revised terms.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>17. Contact Us</h2>
                <p style={styles.paragraph}>For questions, concerns, or clarifications regarding this Agreement, please contact:</p>
                <p style={styles.contact}>
                    <b>JSKM Technologies Private Limited</b> <br />
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                    🌐 <b>Website:</b>{" "}
                    <a
                        href="https://www.jskmtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        https://www.jskmtechnologies.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default UserAgreement;